import { TypographyProps, TypographyVariants } from './types';

export const typographyClassesMap: { [K in keyof TypographyVariants]: Record<TypographyVariants[K], string> } = {
  interface: {
    tiny: 'text-interface-tiny leading-interface-small tracking-interface-small',
    small: 'text-interface-small leading-interface-small tracking-interface-small',
    regular: 'text-interface-regular leading-interface-regular tracking-interface-regular',
    large: 'text-interface-large leading-interface-large tracking-interface-large',
  },
  display: {
    small: 'text-display-small leading-display-small tracking-display-small',
    regular: 'text-display-regular leading-display-regular tracking-display-regular',
    large: 'text-display-large leading-display-large tracking-display-large',
  },
  body: {
    small: 'text-body-small leading-body-small tracking-body-small',
    regular: 'text-body-regular leading-body-regular tracking-body-regular',
    large: 'text-body-large leading-body-large tracking-body-large',
  },
};

export const getTypographyClassNames = <T extends keyof TypographyVariants>({
  variantSize,
  variant,
}: TypographyProps<T>) => {
  if (!variant) return '';

  const variantClasses = typographyClassesMap[variant];

  const fallbackSizeKey: TypographyVariants[T] = 'regular';
  const sizeClasses = variantSize ? variantClasses[variantSize] : variantClasses[fallbackSizeKey];

  return sizeClasses;
};
